import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'phonecall/category';

export function usePhoneCallCategoriesQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IPhoneCallCategory[]>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: BASE_QUERY_KEY }),
				'GET'
			),
		queryKey: [BASE_QUERY_KEY, userSession.account?.id],
		select: categories => [...(categories ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
		meta: {
			errorLogging: { category: 'PhoneCall', action: 'PhoneCallCategoriesQuery-Error' },
			toastErrorMessage: 'Failed to load categories',
		},
	});
}

export const invalidatePhoneCallCategoriesQueries = () =>
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
